import { cn } from '@utils';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export const FieldSideAction: React.FC<Props> = ({ className, children }) => {
  return (
    <div
      className={cn(
        'flex items-center rounded-r-lg bg-neural-01 p-2 transition-colors peer-hover:bg-primary-subtle',
        className,
      )}
    >
      {children}
    </div>
  );
};
